<template>
    <div v-show="block.display" class="home-block" v-observe-visibility="{
            callback: visibilityChanged,
            once: true,
            intersection:{
                rootMargin: `${block.observeMargin}px 0px ${block.observeMargin}px 0px`
            }
        }" :id="block.elementId">
        <h2 v-html="block.title"></h2>
        <div class="home-block-content">
            <div v-show="backShow" class="block-back" @click="back">
                <span class=" ecom-chevron-left"></span>
            </div>
            <div class="categories-content" ref="block" @scroll="scrollEvent">
                <div class="slider-margin">&nbsp;</div>
                <template v-if="block.isLoading">
                    <div v-for="n in nImages" class="category-item" :key="n" :style="{width: `${catWidth}px`,height: `${catWidth / 2}px`}">
                        <div class="category-item-border w-100 h-100 skeleton-box"></div>
                    </div>
                </template> 
                <div v-for="cat in block.dataContent" :key="cat.id" class="category-item" :style="{width: `${catWidth}px`, minHeight: `${catWidth / 2}px`}">
                    <div class="category-item-border w-100 h-100" @click.ctrl="() => {return true;}" @click.exact="gotoCategory(cat.url)">
                        <div class="category-item-radius h-100 w-100" :style="{backgroundColor: cat.color ? cat.color : null}">
                            <a :href="cat.url" class="w-100 h-100 slider-item-href" :aria-label="cat.name">&nbsp;</a>
                            <!-- <LoadImage :loadingStyles="{width: `${catWidth}px`,height: `${catWidth / 2}px`}" :classNames="'img-fluid w-100'" :srcImg="cat.img" :srcSet="cat.img" :title="cat.name"></LoadImage>-->
                            <div class="category-item-content h-100 w-100 d-flex justify-content-center align-items-center">
                                <span>{{cat.name}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="slider-margin">&nbsp;</div>
            </div>
            <div v-show="nextShow" class="block-next" @click="forward">
                <span class=" ecom-chevron-right"></span>
            </div>
        </div>
    </div>
</template>
<script>
import LoadImage from '@/components/ProductPage/Desktop/LoadImage';
import HomeBlock from '@/models/home-block';
import homeUtils from '@/Utilities/homeUtils';
export default {
    components:{
        LoadImage
    },
    props:{
        block:{
            type: HomeBlock
        },
        margin:{
            type: Number,
            default: 3
        },
        relativeViewport: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            catWidth: 0,
            backShow: false,
            nextShow: false
        }
    },
    mounted() {
        this.resize();
        this.$nextTick(() => {
            if (this.relativeViewport) {
                setTimeout(() => {
                    this.resize();
                }, 300);
            }
        });
    },
    created() {
        window.addEventListener("resize", this.resize);
    },
    updated(){
        const elem = this.$refs.block;
        if(elem.scrollLeft == 0){
            this.nextShow = this.block.length > this.nImages;
        }
    },
    destroyed() {
        window.removeEventListener("resize", this.resize);
    },
    computed: {
        nImages(){
            return this.block.numberItens;
        }
    },
    methods: {
        visibilityChanged(isVisible){
            if(isVisible){
                this.block.load();
            }
        },
        gotoCategory(url){
            homeUtils.gotoUrl(url,this.block);
        },
        resize(){
            let viewWidth    = homeUtils.getViewPortWidth();
            let marWidth     = Math.round(viewWidth * (this.margin * 2 / 100));
            let cWidth       = (viewWidth - marWidth) / this.nImages;
            this.catWidth    = Math.round(cWidth);
        },
        scrollEvent(){
            const elem    = this.$refs.block;
            this.nextShow = elem.scrollWidth > elem.scrollLeft + (this.catWidth * (this.nImages + 1));
            this.backShow = elem.scrollLeft > 10;
        },
        back(){
            const elem  = this.$refs.block;
            const left  = this.catWidth;
            const value = left > 0 ? -left : 0;
            this.smoothScrolling(elem,value);
        },
        forward(){
            const elem  = this.$refs.block;
            this.smoothScrolling(elem,this.catWidth);
        },
        smoothScrolling(e,value){
            e.scrollBy({
                top: 0, 
                left: value,
                behavior: 'smooth'
            });
        },
    }
}
</script>